// utils
import PadCreatorPrescriptionDiet from '../components-js/pad-prescription/PadPrescriptionDiet';

const TEMPLATE_NAME = 'PAD_CREATOR_PRESCRIPTION_DIET';

const initialState = {
  errors: [],
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.setLoading(true).setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const prescriptionDiets = action.payload;

      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.prepare(prescriptionDiets).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload.data;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .add(prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_APPLY_PREDEFINED_PAD_MODEL`: {
      const prescriptionForm = action.payload.data;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription.add(prescriptionForm).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      return padCreatorPrescription
        .edit(code, prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .remove(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_SUSPEND`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .suspend(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_UNSUSPEND`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadCreatorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .unsuspend(code, prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
